import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["course", "right"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import routes from "@/lib/routes";
import { ButtonLink } from "@/components/Buttons/index";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContractButtonLink(_ref) {
  let {
      course,
      right
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const contractAllowed = (course === null || course === void 0 ? void 0 : course.contractAllowed) || (right === null || right === void 0 ? void 0 : right.contractAllowed);
  const {
    0: text,
    1: color
  } = useMemo(() => {
    if (contractAllowed) {
      return ["購入する", {
        fillColor: true
      }];
    } else {
      return ["販売期間外", {
        fillGray: true
      }];
    }
  }, [contractAllowed]);
  const href = useMemo(() => {
    if (course) {
      return routes.svodPaymentStep(course.id, 1);
    } else if (right) {
      return routes.subscriptionByRight(right.id);
    }
  }, [course, right]);
  if (!href) return null;
  return /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread(_objectSpread({
    href: href,
    disabled: !contractAllowed
  }, color), props), {}, {
    children: text
  }));
}